export default __webpack_public_path__ + "static/media/mulher-sorrindo-com-notebook.da9d335f.png";